import DefaultLocationModal from "./DefaultLocationModal";

export default DefaultLocationModal